import { render } from "./MenuDetailInDialog.vue?vue&type=template&id=004a5360&scoped=true"
import script from "./MenuDetailInDialog.vue?vue&type=script&lang=js"
export * from "./MenuDetailInDialog.vue?vue&type=script&lang=js"

import "./MenuDetailInDialog.vue?vue&type=style&index=0&id=004a5360&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004a5360"]])

export default __exports__